import { useContext, useState, useEffect } from "react";
import FigureProduct from "@components/FigureProduct";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { useAuth } from "@context/AuthContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const ProductoResultado = ({ producto, ejecutar }) => {
  // console.log(producto)
  const { getToken } = useContext(TokenContext);
  const { openAuth } = useAuth();
  const { translate } = useTranslation();
  const MySwal = withReactContent(Swal)
  const [showSocials, setShowSocials] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const url = process.env.REACT_APP_URL + "detalles-producto/" + producto.uri;

  // Efecto para iterar entre las hover_images cuando el producto está en hover
  useEffect(() => {
    let interval;
    if (isHovered && producto.hover_images && producto.hover_images.length > 1) {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          return (prevIndex + 1) % producto.hover_images.length;
        });
      }, 1500); // 1.5 segundos
    } else {
      setCurrentImageIndex(0); // Resetear al primer índice cuando no está en hover
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isHovered, producto.hover_images]);

  const AddToHeart = async (event, id) => {
    try {
      if (!getToken()) {
        openAuth('IniciarSesionWith');
        return;
      }
      const res = await axios.put(
        "/products/favorite",
        {
          product_id: id,
          status: !producto.favorite
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + getToken()
          }
        }
      );
      producto.favorite = !producto.favorite;

      event.target.classList.toggle('icon-Hearty');
      event.target.classList.toggle('icon-HeartFill');
      if (ejecutar) ejecutar();
      if (res.data.errors) {
        MySwal.fire({
          text: res.data.message,
          icon: 'error',
          title: 'Oops...'
        })
      }
    } catch (error) {
      MySwal.fire({
        text: translate('wishlist.noadd'),
        icon: 'error',
        title: 'Oops...'
      })
    }
  };

  const toggleSocials = () => {
    setShowSocials(!showSocials);
  };

  const handleCopyLink = (event) => {

    event.preventDefault();

    navigator.clipboard.writeText(url).then(() => {

      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    });
  };

  return (
    <>
      <article
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ position: 'relative' }}
      >
        <div>
          {<FigureProduct imagedesktop={producto.desktop_image} imagemovile={producto.movile_image} uri={producto.uri} />}
          {isHovered && producto.hover_images && producto.hover_images.length > 0 && (
            <div 
              className={`product-overlay hovered slider-animation slide-center`}
              style={{
                backgroundImage: `url(${producto.hover_images[currentImageIndex].image})`
              }}
            />
          )}

          <i
            className={!producto.favorite ? "icon-Hearty" : "icon-HeartFill"}
            style={{ color: !producto.favorite ? "" : "red" }}
            onClick={(event) => { AddToHeart(event, producto.id); }}
          ></i>
          <i className="icon-Share" onClick={toggleSocials}></i>
          {showSocials && (
            <div className="socials-list">
              <a target="_blank" href={'https://www.facebook.com/sharer/sharer.php?u=' + url} className="social-icon facebook"></a>
              <a href="#" className="social-icon link" onClick={handleCopyLink}></a>
            </div>
          )}
          {/* Bandera de notificación */}
          {showNotification && (
            <div className="notification-banner">
              {translate('product.link')}
            </div>
          )}
        </div>
        <div>
          <div className="ItemDesc">
            <br />
            {((producto.price_offer && producto.offer_price_range)) && <div className="textpromo">{translate('product.discount')}</div>}
            <ul>
              <li>{producto.category}</li>
              <li>{producto.subcategory}</li>
            </ul>
            <h6>{producto.name}</h6>


            {/* Si tiene precio de oferta y rango de oferta, pintamos el rango de oferta, sino, pintamos el rango de precio */}
            {(producto.price_offer && producto.offer_price_range) ?
              <>
                <div className="grid-price">
                  <span>${producto.price_range ?? producto.price}</span>
                  <div className="promo">${producto.offer_price_range}</div>
                </div>
              </>

              : <span>${producto.price_range ?? producto.price}</span>
            }

            <em>{producto.description}</em>
            <br />
            <br />
          </div>
        </div>

      </article>
    </>
  );
};

export default ProductoResultado;